'use client';

import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { motion, AnimatePresence } from 'framer-motion';

const navLinks = [
{ label: 'Home', href: '/' },
{ label: 'About', href: '/about' },
{ label: 'Projects', href: '/projects' },
{ label: 'Skills', href: '/skills' },
{ label: 'Contact', href: '/contact' }];


export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [darkSection, setDarkSection] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [mounted, setMounted] = useState(false);
  const pathname = usePathname();

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const y = window.scrollY;
      setScrolled(y > 40);
      // Switch to light text after scrolling past the initial hero (approx 400px)
      setDarkSection(y > 400);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close menu on route change
  useEffect(() => {
    setMenuOpen(false);
  }, [pathname]);

  // Close on scroll
  useEffect(() => {
    if (menuOpen) {
      const close = () => setMenuOpen(false);
      window.addEventListener('scroll', close, { once: true });
      return () => window.removeEventListener('scroll', close);
    }
  }, [menuOpen]);

  return (
    <>
      <header data-component-id="src/components/Header.tsx:54:6" data-component-path="src/components/Header.tsx" data-component-line="54" data-component-end-line="123" data-component-file="Header.tsx" data-component-name="header" data-component-content="%7B%22elementName%22%3A%22header%22%7D"
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        mounted && scrolled ?
        'glass-panel-dark py-3 shadow-lg shadow-black/10' :
        'bg-transparent py-5'}`
        }>

        <div data-component-id="src/components/Header.tsx:61:8" data-component-path="src/components/Header.tsx" data-component-line="61" data-component-end-line="122" data-component-file="Header.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-6xl%20mx-auto%20px-6%20flex%20items-center%20justify-between%22%7D" className="max-w-6xl mx-auto px-6 flex items-center justify-between">
          {/* Logo */}
          <Link data-component-id="src/components/Header.tsx:63:10" data-component-path="src/components/Header.tsx" data-component-line="63" data-component-end-line="67" data-component-file="Header.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22href%22%3A%22%2F%22%2C%22className%22%3A%22flex%20items-center%20gap-2.5%20group%22%7D" href="/" className="flex items-center gap-2.5 group">
            <span data-component-id="src/components/Header.tsx:64:12" data-component-path="src/components/Header.tsx" data-component-line="64" data-component-end-line="66" data-component-file="Header.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22font-display%20text-sm%20tracking-widest%20text-foreground%20uppercase%20hidden%20sm%3Ablock%22%2C%22textContent%22%3A%22JUSTICE%20ENTSIE%22%7D" className="font-display text-sm tracking-widest text-foreground uppercase hidden sm:block">JUSTICE ENTSIE

            </span>
          </Link>

          {/* Desktop Nav */}
          <nav data-component-id="src/components/Header.tsx:70:10" data-component-path="src/components/Header.tsx" data-component-line="70" data-component-end-line="88" data-component-file="Header.tsx" data-component-name="nav" data-component-content="%7B%22elementName%22%3A%22nav%22%2C%22className%22%3A%22hidden%20md%3Aflex%20items-center%20gap-8%22%7D" className="hidden md:flex items-center gap-8">
            {navLinks?.map((link) =>
            <Link data-component-id="src/components/Header.tsx:72:12" data-component-path="src/components/Header.tsx" data-component-line="72" data-component-end-line="86" data-component-file="Header.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%7D"
              key={link?.href}
              href={link?.href}
              className={`relative text-xs font-medium uppercase tracking-[0.15em] transition-colors duration-300 group ${
              pathname === link?.href ?
              'text-primary' : mounted && darkSection ? 'text-white/90 hover:text-white' : 'text-muted-foreground hover:text-foreground'}`
              }>

                {link?.label}
                <span data-component-id="src/components/Header.tsx:81:16" data-component-path="src/components/Header.tsx" data-component-line="81" data-component-end-line="84" data-component-file="Header.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D"
                className={`absolute -bottom-0.5 left-0 h-px bg-primary transition-all duration-300 ${
                pathname === link?.href ? 'w-full' : 'w-0 group-hover:w-full'}`
                } />

              </Link>
            )}
          </nav>

          {/* CTA */}
          <Link data-component-id="src/components/Header.tsx:91:10" data-component-path="src/components/Header.tsx" data-component-line="91" data-component-end-line="98" data-component-file="Header.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22href%22%3A%22%2Fcontact%22%2C%22textContent%22%3A%22Hire%20Me%22%7D"
            href="/contact"
            className={`hidden md:inline-flex items-center gap-2 px-5 py-2 border rounded-full text-xs font-medium uppercase tracking-widest transition-all duration-300 ${
            mounted && darkSection
              ? 'border-white/50 text-white hover:bg-white hover:text-black' :'border-primary/50 text-primary hover:bg-primary hover:text-primary-foreground'}`}>

            Hire Me
          </Link>

          {/* Hamburger */}
          <button data-component-id="src/components/Header.tsx:101:10" data-component-path="src/components/Header.tsx" data-component-line="101" data-component-end-line="121" data-component-file="Header.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22md%3Ahidden%20flex%20flex-col%20gap-1.5%20p-2%20z-50%20relative%22%7D"
            onClick={() => setMenuOpen(!menuOpen)}
            className="md:hidden flex flex-col gap-1.5 p-2 z-50 relative"
            aria-label="Toggle menu">

            <span data-component-id="src/components/Header.tsx:106:12" data-component-path="src/components/Header.tsx" data-component-line="106" data-component-end-line="109" data-component-file="Header.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D"
              className={`block h-px w-6 bg-foreground transition-all duration-300 origin-center ${
              menuOpen ? 'rotate-45 translate-y-[7px]' : ''}`
              } />

            <span data-component-id="src/components/Header.tsx:111:12" data-component-path="src/components/Header.tsx" data-component-line="111" data-component-end-line="114" data-component-file="Header.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D"
              className={`block h-px w-6 bg-foreground transition-all duration-300 ${
              menuOpen ? 'opacity-0 scale-x-0' : ''}`
              } />

            <span data-component-id="src/components/Header.tsx:116:12" data-component-path="src/components/Header.tsx" data-component-line="116" data-component-end-line="119" data-component-file="Header.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D"
              className={`block h-px w-6 bg-foreground transition-all duration-300 origin-center ${
              menuOpen ? '-rotate-45 -translate-y-[7px]' : ''}`
              } />

          </button>
        </div>
      </header>
      {/* Mobile Menu */}
      <AnimatePresence data-component-id="src/components/Header.tsx:125:6" data-component-path="src/components/Header.tsx" data-component-line="125" data-component-end-line="167" data-component-file="Header.tsx" data-component-name="AnimatePresence" data-component-content="%7B%22elementName%22%3A%22AnimatePresence%22%7D">
        {menuOpen &&
        <motion.div data-component-id="src/components/Header.tsx:127:8" data-component-path="src/components/Header.tsx" data-component-line="127" data-component-end-line="165" data-component-file="Header.tsx" data-component-name="motion.div" data-component-content="%7B%22elementName%22%3A%22motion.div%22%2C%22className%22%3A%22fixed%20inset-0%20z-40%20glass-panel-dark%20flex%20flex-col%20items-center%20justify-center%20gap-8%22%7D"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
          className="fixed inset-0 z-40 glass-panel-dark flex flex-col items-center justify-center gap-8">

            {navLinks?.map((link, i) =>
          <motion.div data-component-id="src/components/Header.tsx:135:10" data-component-path="src/components/Header.tsx" data-component-line="135" data-component-end-line="150" data-component-file="Header.tsx" data-component-name="motion.div" data-component-content="%7B%22elementName%22%3A%22motion.div%22%7D"
            key={link?.href}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 10 }}
            transition={{ delay: i * 0.07, duration: 0.3 }}>

                <Link data-component-id="src/components/Header.tsx:142:16" data-component-path="src/components/Header.tsx" data-component-line="142" data-component-end-line="149" data-component-file="Header.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%7D"
              href={link?.href}
              className={`font-display text-2xl uppercase tracking-widest transition-colors duration-200 ${
              pathname === link?.href ? 'text-primary' : 'text-foreground/80 hover:text-primary'}`
              }>

                  {link?.label}
                </Link>
              </motion.div>
          )}
            <motion.div data-component-id="src/components/Header.tsx:152:12" data-component-path="src/components/Header.tsx" data-component-line="152" data-component-end-line="164" data-component-file="Header.tsx" data-component-name="motion.div" data-component-content="%7B%22elementName%22%3A%22motion.div%22%7D"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0 }}
            transition={{ delay: 0.3 }}>

              <Link data-component-id="src/components/Header.tsx:158:14" data-component-path="src/components/Header.tsx" data-component-line="158" data-component-end-line="163" data-component-file="Header.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22href%22%3A%22%2Fcontact%22%2C%22className%22%3A%22mt-4%20px-8%20py-3%20border%20border-primary%20rounded-full%20font-display%20text-sm%20uppercase%20tracking-widest%20text-primary%20hover%3Abg-primary%20hover%3Atext-primary-foreground%20transition-all%20duration-300%22%2C%22textContent%22%3A%22Hire%20Me%22%7D"
              href="/contact"
              className="mt-4 px-8 py-3 border border-primary rounded-full font-display text-sm uppercase tracking-widest text-primary hover:bg-primary hover:text-primary-foreground transition-all duration-300">

                Hire Me
              </Link>
            </motion.div>
          </motion.div>
        }
      </AnimatePresence>
    </>
  );

}